import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { useCaseStore } from '../store/caseStore';
import { useAuthStore } from '../store/authStore';
import { CasesHeader } from '../components/cases/CasesHeader';
import { Filters } from '../components/cases/Filters';
import { CasesList } from '../components/cases/CasesList';
import { useCaseFilters } from '../hooks/useCaseFilters';
import { TaskCounts } from '../types';

export const Cases: React.FC = () => {
  const navigate = useNavigate();
  const cases = useCaseStore(state => state.cases);
  const { user } = useAuthStore();

  const {
    searchQuery,
    statusFilter,
    practiceAreaFilter,
    advancedFilters,
    practiceAreas,
    filteredCases,
    setSearchQuery,
    setStatusFilter,
    setPracticeAreaFilter,
    handleAdvancedFilterAdd,
    handleAdvancedFilterRemove,
    clearFilters,
  } = useCaseFilters(cases);

  // Calculate task counts for each case
  const getTaskCounts = (caseId: string): TaskCounts => {
    const caseData = cases.find(c => c.id === caseId);
    if (!caseData) return { total: 0, pending: 0, urgent: 0 };

    const myTasks = caseData.tasks.filter(task => task.assignedTo === user?.id);
    const pendingTasks = myTasks.filter(task => 
      task.status !== 'completed' && new Date(task.dueDate) > new Date()
    );
    const urgentTasks = myTasks.filter(task => 
      task.status !== 'completed' && new Date(task.dueDate) < new Date()
    );

    return {
      total: myTasks.length,
      pending: pendingTasks.length,
      urgent: urgentTasks.length
    };
  };

  const handleCaseClick = (caseId: string) => {
    navigate(`/cases/${caseId}`);
  };

  return (
    <Box>
      <CasesHeader />
      
      <Filters
        searchQuery={searchQuery}
        statusFilter={statusFilter}
        practiceAreaFilter={practiceAreaFilter}
        advancedFilters={advancedFilters}
        practiceAreas={practiceAreas}
        onSearchChange={setSearchQuery}
        onStatusChange={setStatusFilter}
        onPracticeAreaChange={setPracticeAreaFilter}
        onAdvancedFilterAdd={handleAdvancedFilterAdd}
        onAdvancedFilterRemove={handleAdvancedFilterRemove}
        onClearFilters={clearFilters}
      />

      <CasesList
        cases={filteredCases}
        getTaskCounts={getTaskCounts}
        onCaseClick={handleCaseClick}
      />
    </Box>
  );
};